import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function CountdownTimer() {
  const {
    display
  } = useCountdown();
  return <div className="fixed top-0 left-0 w-full bg-red-600 text-white z-50 py-3 px-4 shadow-md text-center font-bold text-lg md:text-xl animate-pulse" data-id="element-1">
      <div className="flex items-center justify-center gap-2" data-id="element-2">
        <span data-id="element-3">⚠️ Esta oferta termina pronto:</span>
        <span className="font-mono bg-red-800 px-2 py-0.5 rounded border border-red-400" data-id="element-4">
          {display}
        </span>
      </div>
    </div>;
}